import { render } from "./SelectButton.vue?vue&type=template&id=890fbc3e"
import script from "./SelectButton.vue?vue&type=script&lang=js"
export * from "./SelectButton.vue?vue&type=script&lang=js"

import "./SelectButton.vue?vue&type=style&index=0&id=890fbc3e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__